module.exports = __webpack_public_path__ + "img/ontariotechu-og-image.58205cbb.png";